import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { useConstantValueInvariant } from "@contember/react-utils";
import { useCallback } from "react";
import { PRIMARY_KEY_NAME } from "../bindingTypes.js";
import { Component } from "./Component.js";
import { Entity } from "./Entity.js";
import { Field } from "./Field.js";
import { TreeNodeEnvironmentFactory } from "../dao/TreeNodeEnvironmentFactory.js";
import { SetOrderFieldOnCreate } from "../accessorSorting/SetOrderFieldOnCreate.js";
import { useGetEntitySubTree } from "../accessorPropagation/useGetEntitySubTree.js";
import { useEntitySubTreeParameters } from "../accessorPropagation/useEntitySubTreeParameters.js";
import { MarkerFactory } from "../queryLanguage/MarkerFactory.js";
import { useAccessorUpdateSubscription } from "../accessorPropagation/useAccessorUpdateSubscription.js";
const EntitySubTree = Component(
  (props) => {
    useConstantValueInvariant(props.isCreating, "EntitySubTree: cannot update isCreating");
    const getSubTree = useGetEntitySubTree();
    const parameters = useEntitySubTreeParameters(props);
    const getAccessor = useCallback(
      () => getSubTree(parameters, props.treeRootId),
      [getSubTree, parameters, props.treeRootId]
    );
    const accessor = useAccessorUpdateSubscription(getAccessor);
    return /* @__PURE__ */ jsx(Entity, { ...props, accessor });
  },
  {
    generateBranchMarker: (props, fields, environment) => {
      if ("isCreating" in props && props.isCreating) {
        return MarkerFactory.createUnconstrainedEntitySubTreeMarker(props, fields, environment);
      }
      return MarkerFactory.createEntitySubTreeMarker(props, fields, environment);
    },
    staticRender: (props) => /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsxs(Entity, { ...props, accessor: 0, children: [
        /* @__PURE__ */ jsx(Field, { field: PRIMARY_KEY_NAME }),
        props.children
      ] }),
      props.isCreating && "orderField" in props && /* @__PURE__ */ jsx(
        SetOrderFieldOnCreate,
        {
          orderField: props.orderField,
          newOrderFieldValue: props.newOrderFieldValue,
          entity: props.entity
        }
      )
    ] }),
    generateEnvironment: (props, oldEnvironment) => {
      const environment = oldEnvironment.withVariables(props.variables);
      return TreeNodeEnvironmentFactory.createEnvironmentForEntitySubtree(environment, props);
    }
  },
  "EntitySubTree"
);
export {
  EntitySubTree
};
//# sourceMappingURL=EntitySubTree.js.map
